import { useApiClient } from '@/composables/api-client'
import { createItemsStoreWrapper } from '~/utils/pinia/items-store-setup'
import type { FantasyMemberCard } from '~/types/fantasy'

const createItemsStore = createItemsStoreWrapper<'id', FantasyMemberCard>()

export const useFantasyMemberCardsStore = createItemsStore(
  'fantasy-member-cards',
  {
    path: '/api/v1/fantasy/member/cards',
    idKey: 'id',
    query: {
      expand: ['currentCard.player.team', 'currentCard.labels']
    }
  },
  context => {
    const totalCount = computed(() => context.meta.value?.totalCount)

    const upgradeCard = async (id: number) => {
      const apiClient = await useApiClient()
      const data = await apiClient.post<FantasyMemberCard>(
        `/api/v1/fantasy/member/cards/${id}/upgrade?expand=currentCard.player.team,currentCard.labels`
      )
      context.updateItem(id, data)
      return data
    }

    const sellCard = async (id: number) => {
      const apiClient = await useApiClient()
      const data = await apiClient.delete(
        `/api/v1/fantasy/member/cards/${id}/destroy`
      )
      context.removeItem(id)
      return data
    }

    return { totalCount, upgradeCard, sellCard }
  }
)
